import { useTranslation } from '@thoughtspot/i18n';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { parseDependentsList } from '../utils';
import { TranslationsKeys } from '../variable-interface';
import styles from './dependents-modal.module.scss';
export const DependentsModal = ({ isOpen, onClose, dependents, variableName, }) => {
    const { t } = useTranslation();
    const dependentsList = parseDependentsList(dependents);
    return (React.createElement(Modal, { isOpen: isOpen, size: ModalSize.SMALL, title: t(TranslationsKeys.DEPENDENTS_MODAL_TITLE), dismissButton: {
            text: t('OK'),
        }, onDismiss: onClose },
        React.createElement(Vertical, { spacing: "d", className: styles.modalContent },
            React.createElement(Typography, { variant: "p", color: Colors.base }, t(TranslationsKeys.DEPENDENTS_MODAL_MESSAGE, {
                variableName,
            })),
            React.createElement(Vertical, { spacing: "b", className: styles.dependentsList, "data-testid": "listDependentsId" }, dependentsList.map(dependent => (React.createElement(Horizontal, { key: `dependent-${dependent.type}-${dependent.name}-${dependent.index}`, spacing: "b", className: styles.dependentItem },
                React.createElement(Typography, { variant: "content-label-subhead", className: styles.dependentName, ellipsis: { rows: 1 }, tooltipConfig: {
                        dataTooltipContent: dependent.name,
                    } }, dependent.name),
                dependent.type && (React.createElement(Typography, { variant: "p", color: Colors.base },
                    "(",
                    dependent.type,
                    ")")))))))));
};
//# sourceMappingURL=dependents-modal.js.map